import { createBrowserRouter } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import { publicRoutes } from "./publicRoutes";
import { protectedRoutes } from "./protectedRoutes";

const router = createBrowserRouter([
  ...publicRoutes,
  ...protectedRoutes,
  {
    path: "*",
    element: <NotFound />,
  },
]);

export default router;
